module.exports = __webpack_public_path__ + "img/shenhezhong.eee0a953.png";